import { RouterModule } from '@angular/router';
import { SharedThirdPartyModule } from '@homeleite/shared-third-party';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBoxComponent } from './search-box/search-box.component';
import { AsyncActionDirective } from './async-action';
import { AutofocusDirective } from './autofocus';
import { ConfirmDialogComponent } from './confirm-dialog';
import { DataSelectorComponent } from './data-selector';
import { DataSelectorDialogComponent } from './data-selector-dialog';
import { DateRangePickerComponent } from './date-range-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from './pipes';
import { EntityCardDirective, EntityCardsComponent } from './entity-cards';
import {
    EntityCrudComponent,
    EntityCrudDetailsContentDirective,
    EntityCrudDialogComponent,
    EntityCrudListDirective,
    EntityDeleteDialogComponent
} from './entity-crud';
import { EntityFabDialComponent } from './entity-fab-dial';
import { EntityListPerspectiveComponent } from './entity-list-perspective';
import { EntityTableComponent } from './entity-table';
import { ExpansionFieldsetComponent } from './expansion-fieldset';
import { InputTextDialogComponent } from './input-text-dialog';
import { FileUploadAreaComponent } from './file-upload-area';
import { InputNumberModule } from './input-number';
import { KzMaskDirective } from './mask/kz-mask.directive';
import {
    NgForTrackByIdDirective,
    NgForTrackByIndexDirective,
    NgForTrackByPropertyDirective
} from './ngfor-trackby-property';
import { PercentInputComponent } from './percent-input';
import { NumericOnlyDirective } from './numeric-only';
import {
    EcoFabSpeedDialActionsComponent,
    EcoFabSpeedDialComponent,
    EcoFabSpeedDialTriggerComponent
} from '@ecodev/fab-speed-dial';

const COMPONENTS = [
    AsyncActionDirective,
    AutofocusDirective,
    ConfirmDialogComponent,
    DataSelectorComponent,
    DataSelectorDialogComponent,
    DateRangePickerComponent,
    SearchBoxComponent,
    EntityTableComponent,
    EntityCrudComponent,
    EntityCrudListDirective,
    EntityCrudDialogComponent,
    EntityCrudDetailsContentDirective,
    EntityDeleteDialogComponent,
    EntityFabDialComponent,
    EntityCardsComponent,
    EntityCardDirective,
    EntityListPerspectiveComponent,
    ExpansionFieldsetComponent,
    InputTextDialogComponent,
    FileUploadAreaComponent,
    KzMaskDirective,
    NgForTrackByIdDirective,
    NgForTrackByIndexDirective,
    NgForTrackByPropertyDirective,
    NumericOnlyDirective,
    SearchBoxComponent,
    PercentInputComponent
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedThirdPartyModule,
        InputNumberModule,
        PipesModule,
        EcoFabSpeedDialTriggerComponent,
        EcoFabSpeedDialActionsComponent,
        EcoFabSpeedDialComponent
    ],
    declarations: [...COMPONENTS],
    exports: [...COMPONENTS]
})
export class CommonComponentsModule {}
